/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
import r from"../../../../../core/Error.js";function e(e,n){if(e&&"name"in e){const o=e;return n&&n.error(new r(o.name,o.message,o.details)),!1}return!0}export{e as ok};
